import { ContentCopy } from '@mui/icons-material';
import { Box, Checkbox, FormControlLabel, IconButton, Stack, Tooltip, Typography } from '@mui/material';

type DataGridFooterProps = {
  length: number;
  checked: boolean;
  onChange: (checked: boolean) => void;
  copyApp?: () => void;
};

const DataGridFooter = ({ length, checked, onChange, copyApp }: DataGridFooterProps) => {
  return (
    <Stack
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      py={1}
      px={2}
      border={'1px solid gray'}
    >
      <Box>
        <FormControlLabel
          control={<Checkbox color='default' checked={checked} onChange={(value) => onChange(value.target.checked)} />}
          label={<Typography>See all</Typography>}
        />
      </Box>
      <Box>
        Total Rows: {length}
        {copyApp && (
          <Tooltip title='Copy App Log' placement='top' arrow>
            <IconButton sx={{ ml: 1 }} onClick={() => copyApp()} color='inherit' size='small'>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Stack>
  );
};

export default DataGridFooter;
